import { useSelector } from 'react-redux';

import { getUserId } from 'src/core/selectors/globalSelectors';

export const useUserId = () => useSelector(getUserId) as string;
